module.exports = __webpack_public_path__ + "img/2.da09299b.png";